module.exports = __webpack_public_path__ + "static/mobile-6e556100f7c66da208ddcc8f837ed852.jpg";